import { ArrowRight } from "lucide-react";

// HP4 draft — full-bleed "Virtual Skin Analyzer" band.
const BG = "https://images.unsplash.com/photo-1663497653290-1b8f327096f7?crop=entropy&cs=srgb&fm=jpg&q=85&w=1920";

export const SkinAnalyzerBandV4 = () => (
  <section className="bg-white py-8 lg:py-12" data-testid="hp4-skin-analyzer-band">
    <div className="max-w-[1600px] mx-auto px-5 sm:px-6 lg:px-10">
      <div className="relative overflow-hidden rounded-sm min-h-[300px] lg:min-h-[360px] flex items-center">
        <img src={BG} alt="Virtual Skin Analyzer" className="absolute inset-0 w-full h-full object-cover" draggable={false} />
        <div className="absolute inset-0 bg-[#8B857C]/45" />
        <div className="absolute inset-0 bg-gradient-to-r from-black/45 via-black/15 to-transparent" />
        <div className="relative z-10 px-8 lg:px-16 max-w-[34rem]">
          <div className="font-mono text-[11px] tracking-[0.24em] uppercase text-white/75 mb-3">Skin tools</div>
          <h2 className="text-[28px] sm:text-[34px] lg:text-[44px] leading-[1.05] tracking-[-0.02em] text-white">Virtual Skin Analyzer</h2>
          <p className="mt-4 text-[15px] lg:text-[16px] leading-relaxed text-white/85 max-w-[26rem]">
            Build a personalized routine in minutes. Answer a few questions to get tailored recommendations guided by dermatologist expertise and insights from 15 million facial photos.
          </p>
          <a
            href="https://www.riversol.com/pages/skin-analyzer"
            data-testid="hp4-analyzer-cta"
            className="group mt-7 inline-flex items-center gap-2 bg-white text-neutral-900 rounded-full px-7 py-3.5 text-[12px] tracking-[0.16em] uppercase font-medium hover:bg-riversol-blue hover:text-white transition-colors"
          >
            Get started
            <ArrowRight size={15} strokeWidth={1.8} className="transition-transform group-hover:translate-x-0.5" />
          </a>
        </div>
      </div>
    </div>
  </section>
);

export default SkinAnalyzerBandV4;
